import { __exports as b } from "./index142.js";
import "./index141.js";
import { __exports as g } from "./index143.js";
Object.defineProperty(b, "__esModule", { value: !0 });
b.default = F;
var a = g, S = "html", i = "head", n = "body", E = /<([a-zA-Z]+[0-9]?)/, d = function(e, o) {
  throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
}, T = function(e, o) {
  throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
}, M = typeof window == "object" && window.DOMParser;
if (typeof M == "function") {
  var L = new M(), N = "text/html";
  T = function(e, o) {
    return o && (e = "<".concat(o, ">").concat(e, "</").concat(o, ">")), L.parseFromString(e, N);
  }, d = T;
}
if (typeof document == "object" && document.implementation) {
  var c = document.implementation.createHTMLDocument();
  d = function(e, o) {
    if (o) {
      var t = c.documentElement.querySelector(o);
      return t && (t.innerHTML = e), c;
    }
    return c.documentElement.innerHTML = e, c;
  };
}
var u = typeof document == "object" && document.createElement("template"), w;
u && u.content && (w = function(e) {
  return u.innerHTML = e, u.content.childNodes;
});
var O = (
  /* istanbul ignore next */
  function() {
    return document.createDocumentFragment().childNodes;
  }
);
function F(e) {
  var o, t, v, s, p, l;
  e = (0, a.escapeSpecialCharacters)(e);
  var f = E.exec(e), y = (o = f == null ? void 0 : f[1]) === null || o === void 0 ? void 0 : o.toLowerCase();
  switch (y) {
    case S: {
      var m = T(e);
      if (!(0, a.hasOpenTag)(e, i)) {
        var r = m.querySelector(i);
        (t = r == null ? void 0 : r.parentNode) === null || t === void 0 || t.removeChild(r);
      }
      if (!(0, a.hasOpenTag)(e, n)) {
        var r = m.querySelector(n);
        (v = r == null ? void 0 : r.parentNode) === null || v === void 0 || v.removeChild(r);
      }
      return m.querySelectorAll(S);
    }
    case i:
    case n: {
      var _ = d(e).querySelectorAll(y);
      return (0, a.hasOpenTag)(e, n) && (0, a.hasOpenTag)(e, i) ? (p = (s = _[0].parentNode) === null || s === void 0 ? void 0 : s.childNodes) !== null && p !== void 0 ? p : O() : _;
    }
    default: {
      if (w)
        return w(e);
      var r = d(e, n).querySelector(n);
      return (l = r == null ? void 0 : r.childNodes) !== null && l !== void 0 ? l : O();
    }
  }
}
